import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaFileUpload,
  FaUsers,
  FaSignOutAlt,
  FaTachometerAlt,
  FaBuilding,
  FaFolderOpen,
  FaUserCircle,
  FaTrash,
} from "react-icons/fa";
import UploadDoc from "../components/UploadDoc";
import DocTable from "../components/DocTable";
import FirmDoc from "../components/FirmDoc";
import AllUsers from "../components/AllUsers";
import Dashboard from "../components/Dashboard";
import AllFirms from "../components/AllFirms";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Profile from "../components/Profile";
import RecycleBin from "../components/RecycleBin";

const Home = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeSection, setActiveSection] = useState("dashboard");
  const [userRole, setUserRole] = useState("user"); // default user
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role) setUserRole(user.role);
  }, []);

  const menuItems = [
    { key: "dashboard", icon: <FaTachometerAlt />, label: "Dashboard" },
    { key: "upload", icon: <FaFileUpload />, label: "Add Doc" },
    { key: "addFirm", icon: <FaBuilding />, label: "Add Firm" },
    { key: "view", icon: <FaFolderOpen />, label: "View Doc" },
    ...(userRole === "admin"
      ? [{ key: "users", icon: <FaUsers />, label: "All Users" }]
      : []),
    { key: "profile", icon: <FaUserCircle />, label: "My Profile" },
    { key: "recycle", icon: <FaTrash />, label: "Recycle Bin" },
    { key: "logout", icon: <FaSignOutAlt />, label: "Logout" },
  ];

  const renderContent = () => {
    switch (activeSection) {
      case "dashboard":
        return <Dashboard />;
      case "upload":
        return <UploadDoc />;
      case "view":
        return <FirmDoc setActiveSection={setActiveSection} />;
      case "firmDocs":
        return <DocTable firmOnly={true} />;
      case "users":
        return <AllUsers />;
      case "addFirm":
        return <AllFirms />;
      case "profile":
        return <Profile />;
      case "recycle":
        return <RecycleBin />;
      default:
        return null;
    }
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear(); // Clear stored data
        Swal.fire("Logged Out!", "You have been logged out.", "success");
        navigate("/"); // Redirect to login page
      }
    });
  };

  return (
    <div className="container-fluid p-0">
      {/* Mobile Top Bar */}
      <div className="d-md-none bg-primary text-white p-2 d-flex justify-content-between align-items-center">
        <h5 className="m-0">Menu</h5>
        <FaBars
          className="cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        />
      </div>

      <div
        className="d-flex flex-column flex-md-row"
        style={{ minHeight: "100vh" }}
      >
        {/* Sidebar */}
        {(mobileMenuOpen || window.innerWidth >= 768) && (
          <div
            className={`bg-primary text-white p-3 d-flex flex-column ${
              mobileMenuOpen ? "d-block" : "d-none d-md-flex"
            }`}
            style={{
              width: collapsed ? "60px" : "200px",
              transition: "0.3s",
              ...(collapsed && { alignItems: "center" }),
            }}
          >
            <div className="mb-4 d-flex align-items-center justify-content-between w-100">
              {!collapsed && <h5 className="m-0">Menu</h5>}
              <FaBars
                className="cursor-pointer d-none d-md-inline"
                onClick={() => setCollapsed(!collapsed)}
              />
            </div>

            {menuItems.map((item) => (
              <button
                key={item.key}
                className={`btn btn-link text-white text-start mb-4 w-100 ${
                  activeSection === item.key ? "fw-bold" : ""
                }`}
                onClick={() => {
                  item.key === "logout"
                    ? handleLogout()
                    : setActiveSection(item.key);
                  setMobileMenuOpen(false); // auto-close on mobile
                }}
              >
                <span className="me-2">{item.icon}</span>
                {!collapsed && item.label}
              </button>
            ))}
          </div>
        )}

        {/* Main Content */}
        <div className="flex-grow-1 p-3 bg-light">
          <div className="card shadow p-4">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default Home;
